import IDMGlobals from './../../IDMGlobals';
//
export default class APIPassword {
  constructor(API) {
    this.api = API;
  }
  async reset(userEmail, recaptchaToken) {
    const req = await this.api.newBaseRequest('DELETE', true /*allows role impersonation*/);
    req.path = IDMGlobals.APIPath_User + userEmail + IDMGlobals.APIPath_UserPassword;
    if (recaptchaToken) req.appendQueryParam(IDMGlobals.URLQueryParam_RecaptchaToken, recaptchaToken);
    return await req.exec();
  }
  async confirmReset(updateObj) {
    const req = await this.api.newBaseRequest('POST', true /*allows role impersonation*/);
    req.path = IDMGlobals.APIPath_User + updateObj.username + IDMGlobals.APIPath_UserPassword;
    req.body = {... updateObj};
    return await req.exec();
  }
  async update(updateObj, userID) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = IDMGlobals.APIPath_User + userID + IDMGlobals.APIPath_UserPassword;
    req.body = {...updateObj};
    return await req.exec();
  }
}
